import { useQuery } from "@tanstack/react-query";
import { get } from "./api";

export interface Me { name: string; defaultHourlyRate: number }

/** The signed-in principal plus server defaults; shared cache key with the Layout. */
export function useMe() {
  return useQuery({ queryKey: ["me"], queryFn: () => get<Me>("/api/me"), staleTime: Infinity });
}
